// 📄 components/StepMGGlobalMapping.tsx
import React from 'react';
import { GeneralsFormData } from '../../../../../services/commerce/integrationService.ts';

interface StepMGGlobalMappingProps {
  mgOrgId: string;
  mgCompanyCode: string;
  onChange: (field: keyof GeneralsFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepMGGlobalMapping({
  mgOrgId,
  mgCompanyCode,
  onChange,
  isInvalid
}: StepMGGlobalMappingProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-purple-500/5 border border-purple-500/10 rounded-xl p-3 space-y-1">
        <span className="text-[10px] font-bold text-purple-400 uppercase tracking-widest block">SAP Integration Suite, Managed Gateway</span>
        <p className="font-mono text-xs text-gray-300">
          <span>Managed Gateway → My Projects → Cross-Referencing → Company Code Mapping</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-purple-400">3. Mapeos Globales de Entorno y Cross-Referencing</h3>
        <p className="text-sm text-gray-400 mt-1">
          Establece los mapeos globales de claves entre la estructura lógica de Ariba y la de tu SAP ERP.
          Configura el Organization ID de Ariba (Realm ID) y el mapeo de Sociedad FI (Company Code).
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Organization ID (Ariba Network ID) <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={mgOrgId}
            onChange={(e) => onChange('mgOrgId', e.target.value.toUpperCase())}
            placeholder="ej. AN010002345-T"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-purple-500 ${
              isInvalid && !mgOrgId ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Company Code FI Mapping (Sociedad ERP) <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={mgCompanyCode}
            onChange={(e) => onChange('mgCompanyCode', e.target.value.toUpperCase())}
            placeholder="ej. 1000 o PE01"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-purple-500 ${
              isInvalid && !mgCompanyCode ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>
      </div>
    </div>
  );
}
